import { RangeCheckbox } from '@creditflowresearch/uilib/Checkbox';
import type { TGetCheckboxProps } from '@creditflowresearch/uilib/hooks/useCheckboxRangeSelection';
import { useCorporateBondScreenerMySelectionContext } from '@/creditflowresearch/application/CorporateBondScreener/CorporateBondScreenerMySelectionContext';
import type { ICorporateBondScreenerTrancheRow } from '@/creditflowresearch/application/CorporateBondScreener/useCorporateBondScreener';

interface ICorporateBondScreenerCheckboxCellProps {
  row: ICorporateBondScreenerTrancheRow,
  rowIndex: number,
  getCheckboxProps: TGetCheckboxProps,
}

export const CorporateBondScreenerCheckboxCell = ({
  row,
  rowIndex,
  getCheckboxProps,
}: ICorporateBondScreenerCheckboxCellProps) => {
  const { selectedIds } = useCorporateBondScreenerMySelectionContext();

  return (
    <RangeCheckbox
      key={ row.id }
      name={ row.id }
      dataTest={ `corporateBondScreenerCheckbox-${ rowIndex }` }
      checked={ selectedIds.has(row.id) }
      { ...getCheckboxProps(rowIndex) }
    />
  );
};
